import * as types from './types'

import { AsyncAction } from '@cbgms/base/redux/async-action'
import { IResponse } from '@cbgms/api'
import { Appid, Operatingunit, Roles } from '@cbgms/api/modules/enums'
import { any } from 'prop-types'

interface AuthenticationResult {
  AuthenticationResult: {
    AccessToken: string
  }
}

export interface RedirectURIResult {
  URL: string
}

export const setAPIURLs = (URLs: Record<string, string>) => ({
  type: types.SET_URLS,
  payload: URLs
})

export const getRedirectURI = () =>
  AsyncAction<IResponse<RedirectURIResult>>({
    type: [types.GET_REDIRECT_URL, types.GET_REDIRECT_URL_SUCCESS, types.GET_REDIRECT_URL_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'GET',
        url: '/sso/get-auth-url?AuthProvider=okta'
      }
    }
  })

export const getAzureRedirectURI = () =>
  AsyncAction<IResponse<RedirectURIResult>>({
    type: [types.GET_AZURE_REDIRECT_URL, types.GET_AZURE_REDIRECT_URL_SUCCESS, types.GET_AZURE_REDIRECT_URL_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'GET',
        url: '/sso/get-auth-url?AuthProvider=azure'
      }
    }
  })

interface ILoginData {
  Code: string
  RedirectURL: string
  AuthProvider: string
}

export const changeUserRole = (role: Roles) => ({
  type: types.USER_ROLE_CHANGE,
  payload: {
    role
  }
})

export const changeUserOperatingUnit = (operatingunit: Operatingunit, appId: Appid) => ({
  type: types.USER_OPERATING_UNIT_CHANGE,
  payload: {
    operatingunit,
    appId
  }
})

export const changeDachUserRole = (dach_role: string) => ({
  type: types.DACH_USER_ROLE_CHANGE,
  payload: {
    dach_role
  }
})

export const handleLogin = (data: ILoginData) => ({
  type: [types.USER_LOGIN, types.USER_LOGIN_SUCCESS, types.USER_LOGIN_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'POST',
      url: '/sso/code',
      data,
      credentials: 'include'
    }
  }
})

export const requestNewAccessToken = (emailAddress: string, refreshToken: string, authProvider: string) =>
  AsyncAction<IResponse<AuthenticationResult>>({
    type: [types.CREATE_ACCESS_TOKEN, types.SET_ACCESS_TOKEN, types.USER_LOGOUT],
    payload: {
      api: 'support',
      request: {
        method: 'POST',
        url: '/sso/refresh-token',
        data: {
          EmailAddress: emailAddress,
          RefreshToken: refreshToken,
          AuthProvider: authProvider
        },
        credentials: 'include'
      }
    }
  })

export const logout = () => ({
  type: types.USER_LOGOUT
})

export const actavationFromFunction = (ActivationCode: string) => ({
  type: [types.ACTIVATION_CUSTOMER, types.ACTIVATION_CUSTOMER_SUCCESS, types.ACTIVATION_CUSTOMER_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'POST',
      url: '/customers/checkActivationStatus',
      data: {
        ActivationCode
      }
    }
  },
  Data: any
})

export const actavationFromSubmit = (ActivationCode: string) => ({
  type: [types.ACTIVATION_FROM_BUTTON_CLICK, types.ACTIVATION_FROM_BUTTON_CLICK_SUCCESS, types.ACTIVATION_FROM_BUTTON_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'POST',
      url: '/customers/signUp',
      data: {
        ActivationCode
      }
    }
  },
  Data: any
})
